module.exports = ".PropertyMap {\n  width: 100%;\n  height: 100vh; }\n\n.PropertyMap .ListMap {\n  width: 100% !important;\n  height: 100vh !important; }\n"